export function parseFullName(fullName) {
  const normalizedFullName = (fullName || '').replace(/\s{2,}/g, ' ');
  const arr = normalizedFullName
    .trim()
    .split(' ')
    .reduce((accumulator, it) => {
      if (!/[\~\!\@\#\$\%\^\&\*\.\,]$/g.test(it)) {
        accumulator.push(it);
      }

      return accumulator;
    }, []);

  return [arr[0], arr.length > 1 ? arr[arr.length - 1] : '', normalizedFullName];
}

export function checkFirstName(firstName) {
  const normalizedFirstName = (firstName || '')
    .replace(/\s{2,}/g, ' ')
    .trim()
    .split(' ');

  return !/[\~\!\@\#\$\%\^\&\*\.\,]$/g.test(normalizedFirstName[0]);
}

export function checkLastName(lastName) {
  const normalizedLastName = (lastName || '')
    .replace(/\s{2,}/g, ' ')
    .trim()
    .split(' ');

  return !normalizedLastName.some(it => /[\~\!\@\#\$\%\^\&\*\.\,]$/g.test(it));
}

/**
 * Return changable status of three fields: [fisrt, last, full].
 *
 * The field currently focused, and the other two derived fields, should
 * always stay in sync with each other, regardless of whether they already
 * hold a value.
 */
export function checkNameChangable(focusField) {
  const isNameField = ['firstName', 'lastName', 'fullName'].indexOf(focusField) > -1;

  return { firstName: isNameField, lastName: isNameField, fullName: isNameField };
}
